module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    staticClass: "page-element",
    attrs: {
      "col": "",
      "lg": "4",
      "md": "6",
      "sm": "12"
    }
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Logowanie")]), _vm._v(" "), (_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "login__field"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "login_email"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.email),
      expression: "credentials.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "login_email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.credentials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "login__field"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "login_password"
    }
  }, [_vm._v("Hasło")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "login_password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "login__field"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "login_company"
    }
  }, [_vm._v("Firma")]), _vm._v(" "), _c('dropdown-search', {
    attrs: {
      "id": "login_company",
      "elements": _vm.getSaaSCompanies,
      "emptyValue": "Wybierz firmę",
      "valueField": "@id",
      "nameField": "name"
    },
    model: {
      value: (_vm.credentials.saasCompany),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "saasCompany", $$v)
      },
      expression: "credentials.saasCompany"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "login__field"
  }, [_c('my-button', {
    attrs: {
      "text": "Logowanie",
      "icon": "tick",
      "action": _vm.submit
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20376108","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/security/login.vue
// module id = 791
// module chunks = 0